import styled from '@emotion/styled'
import { palette, spacing } from 'main/ui'
import { NativeLink } from 'main/ui'

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: ${spacing.majorScale(8)}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${palette.goldenrod};
  text-align: center;
  position: fixed;
  z-index: 1;
`

export const ImageContainer = styled.div`
  max-height: 100%;
  margin: 0 ${spacing.majorScale(1)}px;
`

export const StyledNativeLink = styled(NativeLink)`
  color: ${palette.black};
  font-weight: 800;

  &:hover {
    color: ${palette.black};
    text-decoration: underline;
  }
`
